module.exports = __webpack_public_path__ + "static/media/my_addresses_french.006db149.jpg";